import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ResolutionViewedAuditItemDetails = ({ audit }) => (
  <div>
    <span>
      <AuditedUser audit={audit} /> viewed the resolution.
    </span>
  </div>
)

ResolutionViewedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ResolutionViewedAuditItemDetails
